import { render, staticRenderFns } from "./BasicSystemMessageCard.vue?vue&type=template&id=756a2bb2&scoped=true"
import script from "./BasicSystemMessageCard.vue?vue&type=script&lang=js"
export * from "./BasicSystemMessageCard.vue?vue&type=script&lang=js"
import style0 from "./BasicSystemMessageCard.vue?vue&type=style&index=0&id=756a2bb2&prod&scoped=true&lang=css"
import style1 from "./BasicSystemMessageCard.vue?vue&type=style&index=1&id=756a2bb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a2bb2",
  null
  
)

export default component.exports